import { FieldError, FieldErrors } from 'react-hook-form';

interface IFormValues {
  attachments: { file?: string }[];
}

const getAttachmentError = (errors: FieldErrors<IFormValues>, index: number) => {
  return errors.attachments?.[index]?.file as FieldError | undefined;
};

export { getAttachmentError };
